import { ParsedUrlQueryInput } from 'node:querystring';
import { UrlObject } from 'url';
import { buildUrlWithQuery } from '.';

export const buildDashboardUrl = (
  dashboardName: string,
  query?: ParsedUrlQueryInput,
  appAwarePath?: string,
): UrlObject =>
  buildUrlWithQuery(`/dashboards/${appAwarePath ? appAwarePath + '/' : ''}${encodeURIComponent(dashboardName)}`, query);
